import { render } from "./Ipv4GuestSubnetsTab.vue?vue&type=template&id=4ae49f5c&scoped=true"
import script from "./Ipv4GuestSubnetsTab.vue?vue&type=script&lang=js"
export * from "./Ipv4GuestSubnetsTab.vue?vue&type=script&lang=js"

import "./Ipv4GuestSubnetsTab.vue?vue&type=style&index=0&id=4ae49f5c&lang=scss&scoped=true"

import exportComponent from "/root/mold/diplo/dist/rpmbuild/BUILD/cloudstack-4.21.0.0-Diplo-202603161407/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ae49f5c"]])

export default __exports__